import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingbusrentalserviceinpune() {



  const cardData = {
"keyword": "Wedding Bus Rental Services in Pune",

"headingDescription":
  "Aaradhya Travels provides reliable Wedding Bus Rental Services in Pune for marriage ceremonies, guest transportation, family functions, destination weddings, reception events, and group travel requirements. Our fleet includes comfortable luxury buses, mini buses, and tempo travellers with air-conditioning, pushback seats, spacious interiors, music systems, and experienced drivers familiar with Pune wedding venues and highways. We ensure safe, comfortable, and punctual transportation with doorstep pickup for wedding guests, relatives, and event groups across Pune and nearby destinations.",

"topPlaces": [
  {
    "title": "Mahalaxmi Lawns",
    "description":
      "Mahalaxmi Lawns is one of Pune’s most popular wedding venues known for grand marriage celebrations and large family gatherings."
  },
 {
    "title": "Lonavala Destination Weddings",
    "description":
      "Lonavala is a top destination wedding location near Pune known for resorts, hill views, and scenic outdoor wedding setups. It is widely preferred for luxury destination weddings and pre-wedding shoots."
  },
  {
    "title": "Lavasa Wedding Resorts",
    "description":
      "Lavasa offers beautiful lakeside resorts and scenic landscapes, making it a popular destination for intimate wedding ceremonies and luxury celebrations near Pune."
  },
  {
    "title": "Alibaug Beach Weddings",
    "description":
      "Alibaug is one of the most popular beach wedding destinations near Pune and Mumbai, known for seaside mandaps, resorts, and grand destination weddings."
  },
  {
    "title": "Mahabaleshwar Destination Weddings",
    "description":
      "Mahabaleshwar is a famous hill station known for cool climate, valleys, and luxury resorts, making it ideal for romantic destination weddings and receptions."
  },
  {
    "title": "Goa Beach Weddings",
    "description":
      "Goa is India’s most famous beach wedding destination known for luxury resorts, beaches, and vibrant celebrations. It is highly preferred for destination weddings and pre-wedding functions."
  },
  {
    "title": "Oxford Golf Resort",
    "description":
      "Oxford Golf Resort is a premium Pune destination known for lavish weddings, receptions, and luxury celebrations."
  },
  {
    "title": "Shubhankaroti Lawns",
    "description":
      "Shubhankaroti Lawns is a well-known Pune wedding venue suitable for traditional marriages and family events."
  },
  
  {
    "title": "Balewadi High Street",
    "description":
      "Balewadi High Street is a vibrant Pune destination popular for pre-wedding parties, receptions, and social gatherings."
  },
  {
    "title": "Koregaon Park",
    "description":
      "Koregaon Park is a premium Pune locality known for luxury hotels, banquet halls, wedding parties, and social events."
  },

 
],



services: [
  {
    name: "Wedding Bus Pune",
    description: "Wedding bus Pune service provides stylish and comfortable transportation for marriage ceremonies, bridal parties, wedding guests, and family travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Marriage Bus Rental Pune",
    description: "Marriage bus rental Pune service offers dependable transportation for wedding functions, reception events, family gatherings, and guest travel arrangements. Comfortable seating and spacious interiors ensure smooth journeys suitable for local and outstation marriage transportation requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the itinerary. Pickup services are available from homes, marriage halls, hotels, and event venues across Pune. Flexible booking options allow convenient marriage bus rental reservations."
  },
  {
    name: "Wedding Coach Hire Pune",
    description: "Wedding coach hire Pune service provides premium transportation with spacious seating for wedding ceremonies, family gatherings, bridal events, and guest travel. Comfortable interiors and smooth highway travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, and banquet halls across Pune. Flexible booking options allow convenient wedding coach hire reservations."
  },
  {
    name: "Luxury Wedding Bus Pune",
    description: "Luxury wedding bus Pune service provides elegant transportation with modern interiors and comfortable seating for weddings, bridal travel, and VIP guest transportation. Smooth travel and spacious seating ensure premium journeys suitable for marriage events and social gatherings. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the wedding schedule. Pickup services are available from homes, luxury hotels, banquet halls, and airports across Pune. Flexible booking options allow convenient luxury wedding bus reservations."
  },
  {
    name: "AC Wedding Bus Pune",
    description: "AC wedding bus Pune service offers air-conditioned transportation for wedding ceremonies, reception functions, family events, and guest travel requirements. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient AC wedding bus reservations."
  },
  {
    name: "Non AC Wedding Bus Pune",
    description: "Non AC wedding bus Pune service provides affordable transportation for marriage functions, wedding guest travel, family gatherings, and local event transportation. Spacious seating ensures comfortable journeys suitable for budget-friendly wedding transportation requirements. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the itinerary. Pickup services are available from homes, banquet halls, hotels, and event venues across Pune. Flexible booking options allow convenient non AC wedding bus reservations."
  },
  {
    name: "17 Seater Wedding Bus Pune",
    description: "17 seater wedding bus Pune service offers comfortable transportation for wedding guests, bridal parties, family travel, and marriage event transportation. Spacious seating and smooth travel ensure pleasant journeys suitable for medium-sized wedding groups. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, banquet halls, and hotels across Pune. Flexible booking options allow convenient 17 seater wedding bus reservations."
  },
  {
    name: "25 Seater Wedding Bus Pune",
    description: "25 seater wedding bus Pune service provides spacious transportation for wedding functions, guest transfers, family gatherings, and reception travel requirements. Comfortable seating and luggage space ensure smooth journeys suitable for medium-sized marriage groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient 25 seater wedding bus reservations."
  },
  {
    name: "35 Seater Wedding Bus Pune",
    description: "35 seater wedding bus Pune service offers reliable transportation for marriage ceremonies, destination weddings, bridal travel, and guest transportation. Spacious seating and comfortable interiors ensure pleasant journeys suitable for larger wedding groups. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the wedding itinerary. Pickup services are available from homes, hotels, airports, and marriage halls across Pune. Flexible booking options allow convenient 35 seater wedding bus reservations."
  },
  {
    name: "50 Seater Wedding Bus Pune",
    description: "50 seater wedding bus Pune service provides spacious transportation for grand wedding events, family travel, guest movement, and destination marriage functions. Comfortable seating and luggage space ensure smooth journeys suitable for large wedding groups and event transportation. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, banquet halls, airports, and hotels across Pune. Flexible booking options allow convenient 50 seater wedding bus reservations."
  },
  {
    name: "Wedding Guest Transport Pune",
    description: "Wedding guest transport Pune service provides dependable transportation for family members, invited guests, bridal groups, and marriage event travel requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation wedding transportation. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, banquet halls, and railway stations across Pune. Flexible booking options allow convenient wedding guest transport reservations."
  },
  {
    name: "Wedding Shuttle Service Pune",
    description: "Wedding shuttle service Pune offers reliable transportation between hotels, wedding venues, banquet halls, and airports for marriage guests and family groups. Comfortable seating ensures smooth travel suitable for local wedding transportation and event movement. Professional chauffeurs ensure dependable transportation and timely pickup services throughout the itinerary. Pickup services are available from homes, hotels, airports, and event venues across Pune. Flexible booking options allow convenient wedding shuttle service reservations."
  },
  {
    name: "Wedding Outstation Bus Pune",
    description: "Wedding outstation bus Pune service provides dependable long-distance transportation for destination weddings, family functions, bridal travel, and guest transportation. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, and banquet halls across Pune. Flexible booking options allow convenient outstation wedding bus reservations."
  },
  {
    name: "Destination Wedding Bus Pune",
    description: "Destination wedding bus Pune service offers spacious transportation for outstation marriage functions, resort weddings, family travel, and guest transportation requirements. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for long-distance wedding events. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, airports, and wedding venues across Pune. Flexible booking options allow convenient destination wedding bus reservations."
  },
  {
    name: "Wedding Pickup Drop Pune",
    description: "Wedding pickup drop Pune service provides reliable transportation for bridal parties, family members, wedding guests, and airport transfers. Comfortable seating and punctual pickup services ensure smooth journeys suitable for local and outstation wedding travel requirements. Professional chauffeurs ensure safe transportation and dependable driving services throughout the itinerary. Pickup services are available from homes, airports, hotels, and marriage halls across Pune. Flexible booking options allow convenient wedding pickup and drop reservations."
  },
  {
    name: "Hinjewadi Wedding Bus Pune",
    description: "Hinjewadi wedding bus Pune service provides dependable transportation for marriage functions, guest travel, family gatherings, and destination wedding events. Spacious seating ensures smooth journeys suitable for office employees, family groups, and wedding transportation requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and event venues across Hinjewadi Pune. Flexible booking options allow convenient Hinjewadi wedding bus reservations."
  },
  {
    name: "Kharadi Wedding Bus Pune",
    description: "Kharadi wedding bus Pune service offers reliable transportation for wedding ceremonies, family events, airport transfers, and guest travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for corporate employees and family groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and commercial hubs across Kharadi Pune. Flexible booking options allow convenient Kharadi wedding bus reservations."
  },
  {
    name: "Baner Wedding Bus Pune",
    description: "Baner wedding bus Pune service provides comfortable transportation for marriage events, family travel, airport pickups, and guest transportation. Spacious seating and luggage space ensure smooth journeys suitable for local and outstation wedding travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, banquet halls, and residential areas across Baner Pune. Flexible booking options allow convenient Baner wedding bus reservations."
  },
  {
    name: "Wakad Wedding Bus Pune",
    description: "Wakad wedding bus Pune service provides reliable transportation for marriage ceremonies, guest travel, airport transfers, and outstation wedding functions. Comfortable seating and smooth travel ensure pleasant journeys suitable for business and leisure wedding travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, and event venues across Wakad Pune. Flexible booking options allow convenient Wakad wedding bus reservations."
  },
  {
    name: "Pimpri Wedding Bus Pune",
    description: "Pimpri wedding bus Pune service offers dependable transportation for marriage events, family vacations, wedding functions, and airport transfers. Spacious seating and luggage capacity ensure smooth journeys suitable for local and outstation passenger movement. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Pune. Flexible booking options allow convenient Pimpri wedding bus reservations."
  },
  {
    name: "Affordable Wedding Bus Pune",
    description: "Affordable wedding bus Pune service provides economical transportation for marriage functions, family gatherings, guest travel, and local or outstation wedding trips. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly wedding transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient affordable wedding bus reservations."
  },
  {
    name: "Premium Wedding Bus Pune",
    description: "Premium wedding bus Pune service offers luxury transportation with spacious interiors and comfortable seating for marriage ceremonies, family travel, and guest transportation. Smooth journeys and modern amenities ensure pleasant travel experiences suitable for executive passengers and wedding groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from luxury hotels, homes, banquet halls, and airports across Pune. Flexible booking options allow convenient premium wedding bus reservations."
  },
  {
    name: "Wedding Group Travel Pune",
    description: "Wedding group travel Pune service offers spacious transportation for family celebrations, guest movement, bridal events, and social gatherings. Comfortable seating ensures pleasant journeys suitable for medium and large wedding passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient wedding group travel reservations."
  },
  {
    name: "Marriage Event Transport Pune",
    description: "Marriage event transport Pune service provides dependable transportation for bridal parties, wedding guests, family gatherings, and reception travel requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation marriage transportation. Professional chauffeurs ensure punctual transportation and safe driving services throughout the itinerary. Pickup services are available from homes, hotels, banquet halls, and event venues across Pune. Flexible booking options allow convenient marriage event transport reservations."
  },
  {
    name: "Wedding Booking Bus Pune",
    description: "Wedding booking bus Pune service provides reliable transportation for weddings, business events, sightseeing tours, concerts, and family gatherings. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation wedding transportation. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and event venues across Pune. Flexible booking options allow convenient wedding booking bus reservations."
  }
],

tableData: [
  ["Wedding Bus Pune", "Marriage Bus Rental Pune"],
  ["Wedding Coach Hire Pune", "Luxury Wedding Bus Pune"],
  ["AC Wedding Bus Pune", "Non AC Wedding Bus Pune"],
  ["17 Seater Wedding Bus Pune", "25 Seater Wedding Bus Pune"],
  ["35 Seater Wedding Bus Pune", "50 Seater Wedding Bus Pune"],
  ["Wedding Guest Transport Pune", "Wedding Shuttle Service Pune"],
  ["Wedding Outstation Bus Pune", "Destination Wedding Bus Pune"],
  ["Wedding Pickup Drop Pune", "Hinjewadi Wedding Bus Pune"],
  ["Kharadi Wedding Bus Pune", "Baner Wedding Bus Pune"],
  ["Wakad Wedding Bus Pune", "Pimpri Wedding Bus Pune"],
  ["Affordable Wedding Bus Pune", "Premium Wedding Bus Pune"],
  ["Wedding Group Travel Pune", "Marriage Event Transport Pune"],
  ["Wedding Booking Bus Pune", "Luxury Wedding Bus Pune"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable Wedding Bus Rental Services in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable wedding bus rental services in Pune with comfortable vehicles, professional drivers, and smooth transportation arrangements for wedding guests, family members, and event travel."
      },
      {
        WhyChooseheading: "Affordable Wedding Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable wedding bus rental packages in Pune with transparent pricing, flexible booking plans, and complete transportation support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Wedding Transportation Service",
        WhyChoosedescription: "Our wedding bus rental service in Pune operates 24 hours for baraat travel, guest pickup and drop, wedding venue transfers, airport transfers, and family transportation."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Wedding Buses",
        WhyChoosedescription: "All buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for comfortable wedding group travel experiences."
      },
      {
        WhyChooseheading: "Customized Wedding Travel Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized wedding transportation plans including guest pickup, multi-location transfers, outstation wedding travel, and complete event transportation management."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, 25 seater, 32 seater, 35 seater, 40 seater, and 50 seater buses suitable for wedding guests and large family groups."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pune Airport, railway stations, hotels, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Smooth Wedding Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth coordination, and timely transportation for wedding ceremonies, receptions, family events, and outstation wedding travel."
      }
    ]
  };

  const faqData = [
    { question: "What are wedding bus rental services in Pune?", answer: "Wedding bus rental services in Pune provide comfortable group transportation for wedding guests, family members, baraat travel, and event transportation." },
    { question: "Is wedding bus booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 wedding bus rental services in Pune." },
    { question: "Which bus seating options are available for weddings?", answer: "Aaradhya Travels offers 14 seater, 17 seater, 20 seater, 25 seater, 32 seater, 35 seater, 40 seater, and 50 seater buses for wedding transportation." },
    { question: "Can I book wedding buses for outstation marriage events?", answer: "Yes, customers can book buses for destination weddings, outstation marriage events, and family travel from Pune." },
    { question: "Do you provide AC buses for weddings in Pune?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC buses for comfortable wedding transportation." },
    { question: "Can I book buses for baraat and guest pickup services?", answer: "Yes, our buses are ideal for baraat travel, guest pickup and drop, and complete wedding event transportation." },
    { question: "Can I book wedding bus rental service online?", answer: "Yes, customers can easily book wedding bus rental services online or through phone booking." },
    { question: "Do you provide airport and hotel pickup for wedding guests?", answer: "Yes, Aaradhya Travels provides airport, railway station, and hotel pickup and drop services for wedding guests." },
    { question: "Are wedding bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for wedding bus rental service?", answer: "Yes, advance booking is available and highly recommended during wedding seasons, weekends, and festive periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Deshmukh",
    feedback:
      "The wedding bus rental service in Pune by Aaradhya Travels made guest transportation very smooth. Everyone reached the venue on time, and the travel arrangement was well coordinated throughout the event.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Aaradhya Travels handled our wedding bus rental in Pune very professionally. The vehicle was clean and comfortable, and it helped us manage guest movement between venues without any stress.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Bus Rental Services in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/wedding-bus-rental-pune.jpg",
  "description": "Book Wedding Bus Rental Services in Pune with Aaradhya Travels for marriage functions, guest transportation, and wedding shuttle services. Available AC and non-AC buses in 17, 25, 35, and 50 seater options for smooth wedding travel across Pune and outstation routes.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "10890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/wedding-bus-rental-services-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Wedding Bus Rental Services in Pune | Marriage & Guest Transport | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Wedding Bus Rental Services in Pune with Aaradhya Travels. AC and Non-AC buses available in 17, 25, 35, and 50 seater options for marriage functions, guest transport, and wedding shuttle services across Pune and outstation locations."
  />

  <meta
    name="keywords"
    content="Wedding bus Pune, marriage bus rental Pune, wedding coach hire Pune, luxury wedding bus Pune, AC wedding bus Pune, non AC wedding bus Pune, 17 seater wedding bus Pune, 25 seater wedding bus Pune, 35 seater wedding bus Pune, 50 seater wedding bus Pune, wedding guest transport Pune, wedding shuttle Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingbusrentalserviceinpune ;